module.exports = __webpack_public_path__ + "static/real-van-937679fafa618d2edc983c7db536258e.png";